import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import '../../../case/docket/Docket.less';
import { formatUnixDate } from '../../../../utils/dateFormat';

class CaseActivityClaimsRow extends Component {
  constructor(props) {
    super(props);
    this.state = { showHistory: false };
  }

  onShowHistory = () => {
    this.setState({showHistory: !this.state.showHistory});
  };

  render() {
    const { row } = this.props;
    const creditor = row.creditor.split('\n')[0];
    const address = row.creditor.replace(creditor, '');

    return (
      <tbody>
      <tr>
        <td>
          <a
            href="#"
            className="docket_no in-inforuptcy"
            onClick={e => {
              e.preventDefault(); this.onShowHistory();
            }}
          >
            {row.claim_no}
          </a>
        </td>
        <td>
          {row.info && row.info.original_filed_date}
        </td>
        <td>
          {creditor}
        </td>
        <td style={{ textAlign: 'right' }}>
          ${row.amounts && row.amounts.amount && row.amounts.amount.claimed || '0.00'}
        </td>
        <td>
          {formatUnixDate(row.timestamp)}
        </td>
      </tr>
      <tr className="claim-detail claim" style={{ display: this.state.showHistory ? 'table-row': 'none' }}>
        <td/>
        <td>
          {row.info.original_filed_date && <div>Original Filed Date: {row.info.original_filed_date}</div>}
          {row.info.last_amendment_filed && <div>Last Amendment Filed: {row.info.last_amendment_filed}</div>}
          {row.info.original_entered_date && <div>Original Entered Date: {row.info.original_entered_date}</div>}
          {row.info.last_amendment_entered && <div>Last Amendment Entered: {row.info.last_amendment_entered}</div>}
        </td>
        <td style={{ whiteSpace: 'pre-wrap' }}>
          {address}
        </td>
        <td style={{ textAlign: 'right' }}>
          {row.amounts && row.amounts.unknown && <div>Unknown: {row.amounts.unknown.claimed}</div>}
          {row.amounts && row.amounts.priority && <div>Priority: {row.amounts.priority.claimed}</div>}
          {row.amounts && row.amounts.secured && <div>Secured allowed: {row.amounts.secured.claimed}</div>}
          {row.amounts && row.amounts.unsecured && <div>Unsecured: {row.amounts.unsecured.claimed}</div>}
          {row.amounts && row.amounts.admin && <div>Admin: {row.amounts.admin.claimed}</div>}
        </td>
        <td/>
      </tr>
      <tr className="claim-detail claim" style={{ display: this.state.showHistory ? 'table-row': 'none' }}>
        <td />
        <td colSpan="4">
          {/*<a href="#" className="faded danger right"
             onClick="delete_and_repurchase_claim_entry(this, '2'); return false;">Redact Entry</a>*/}
          <u>History / Documents</u><br/>
          <table>
            <tbody>
              {row.history.map(doc =>
                doc.claim_no &&
                  <tr>
                    <td className="view_detail_width">
                      <div className="view_details"><strong>{doc.claim_no}</strong></div>
                    </td>
                    <td>{doc.claim_text}</td>
                  </tr>
              )}
            </tbody>
          </table>
          <u>Related Dockets</u><br/>
          <table>
            <tbody>
              {row.history.map(doc =>
                doc.docket_no &&
                  <tr key={doc.docket_no}>
                    <td className="view_detail_width">
                      {/*TODO: Add onClick functionality*/}
                      <a href="#" className="view_details unknown-purchase-status"><strong>{doc.docket_no}</strong></a>
                    </td>
                    <td>{`${doc.docket_date} ${doc.docket_text}`}</td>
                  </tr>
              )}
            </tbody>
          </table>
        </td>
      </tr>
      <tr className="claim-detail claim" style={{ display: this.state.showHistory ? 'table-row': 'none' }}>
        <td/>
        <td colSpan="4" >
          <table className="borderless-table">
            <tbody>
            {row.description &&
              <tr>
                <td>Description:</td>
                <td width="100%"dangerouslySetInnerHTML={{ __html: row.description }} />
              </tr>
            }
            {row.remarks &&
              <tr>
                <td>Remarks:</td>
                <td width="100%"dangerouslySetInnerHTML={{ __html: row.remarks }} />
              </tr>
            }
            </tbody>
          </table>
        </td>
      </tr>
      </tbody>
    );
  }
}

CaseActivityClaimsRow.propTypes = {
  row: PropTypes.any.isRequired,
};

export default CaseActivityClaimsRow;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/CaseActivityClaimsRow.jsx